import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/22/thumb-landscape.jpg"

const Post22 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FERRAGAMO／ヴァラ／13 x18 x13cm</span> 
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>イタリア創業のハイブランド「フェラガモ（FERRAGAMO）」。<br></br>フェラガモ、と聞くと靴を思い浮かべる方も多いかもしれませんね。1927年の創業当初は靴のファッションブランドとして名を馳せ、マリリン・モンローやオードリー・ヘプバーンなど多数のハリウッド女優や各国の王族が愛用していたことも有名です。そんな歴史ある靴作りから活かされた、高品質でクオリティの高いバッグは幅広い世代の女性から支持を得ています。<br></br>そこで今回は、洗練された大人女子にぴったりなフェラガモの人気バッグ１０選をご紹介します！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>トップハンドルバッグ</h2>
          <p>台形フォルムのバッグに、フェラガモの代表的なアイテムの一つである「ガンチーニ（小さなフック）」が付いたバッグ。すっきりとした見た目ですが、中は仕切りとファスナーポケットもある大容量。パーティーなどのフォーマルシーンにもぴったりのバッグです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/22/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/2.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">FERRAGAMO／ガンチーニ／27 x19 x10cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/3.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/4.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FERRAGAMO／ガンチーニ／27 x20 x10cm</span>   
        <div className="text-max-width">
          <h2>チェーントートバッグ</h2>
          <p>フェラガモのもう一つのシンボルである「ヴァラ（ロゴが刻印されたバックルにリボンを通したモチーフ）」とチェーンストラップが印象的なトートバッグ。フェミニンなデザインですが、丈夫な作りなので普段使いにもオススメのバッグです。</p>          
        </div>          
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FERRAGAMO／チェーントートバッグ／33 x23 x12cm</span>   
        <div className="text-max-width">
          <h2>エイミー</h2>
          <p>直線的でシンプルなシルエットと、A４サイズも入るサイズ感がお仕事バッグに最適です。フロントに刻印されたフェラガモのブランドロゴと、揺れるフリンジがエレガントな雰囲気を演出してくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/7.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/22/8.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">FERRAGAMO／トートバッグ／28 x25 x13cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/9.jpg" alt="" />
              <span className="text-center">FERRAGAMO／エイミー／22 x21 x10cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/10.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ガンチーニ2WAYバッグ／23 x20 x11cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バティック</h2>
          <p>フェラガモらしいしっかりとしたフォルムと、バッグのフロントについたメタルパーツが上品で高級感のある印象を作ってくれます。フォーマルでも、デニムやワンピースのようなカジュアルなスタイルに合わせてもカッコよく決まります。</p>
        </div>
        <div className="img-two-cloumn">
        <figure className="img-small">
              <StaticImage src="../../images/posts/22/11.jpg" alt="" />
            </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/12.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">FERRAGAMO／2WAYバッグ／23 x17 x9cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/13.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ガンチーニ／38 x28 x19cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/14.jpg" alt="" />
              <span className="text-center">FERRAGAMO／2WAYバッグ／30 x22 x14cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ホーボー</h2>
          <p>デイリーに活躍する大人のレザーバッグとして人気の高いショルダーバッグです。シンプルでありながらも上品さのあるデザインなのでオンオフ問わず使える優れもの。</p>
        </div>
        <figure className="img-small">
              <StaticImage src="../../images/posts/22/15.jpg" alt="" />
        </figure>   
        <span className="text-center">FERRAGAMO／ショルダーバッグ／25 x20 x6cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/16.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ショルダーバッグ／25 x20 x6cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/17.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ガンチーニ／37 x20 x5cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/ferragamo" className="view-all-button">
          フェラガモのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>ソフィア</h2>
          <p>小さめのガンチーニがデザインされたシンプルな印象のバッグ。柔らかいカーフレザーを使用しているので、傷が付きにくく普段使いにぴったりのアイテムです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/18.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/19.jpg" alt="" />
          </figure>
        </div>       
        <span className="text-center">FERRAGAMO／ソフィア／38 x23 x15cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/20.jpg" alt="" />
              <span className="text-center">FERRAGAMO／2WAYバッグ／23 x18 x12cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/21.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ガンチーニ／24 x17 x12cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トレーシー</h2>
          <p>大きすぎないサイズ感とフェミニンなデザインは、デートや女子会など様々なシーンで使いやすいバッグです。ショルダーストラップ付きで、斜め掛けや肩掛けなど、その日のコーデや気分に合わせて変化を楽しめるのも魅力。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/22.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/23.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">FERRAGAMO／ヴァラ／26 x20 x6cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/24.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ヴァラ／25 x20 x6cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/25.jpg" alt="" />
              <span className="text-center">FERRAGAMO／トレーシー／24.5-26 x20 x7.5cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>フラップショルダーバッグ</h2>
          <p>ストラップの持ち方を変えることで、ショルダー、斜め掛け、クラッチ、そして二重にしてハンドバッグなど、さまざまなスタイルが楽しめるバッグ。ちょっとしたお出かけやパーティーシーンにもおすすめです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/26.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/27.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">FERRAGAMO／ガンチーニ／22 x15 x7cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/28.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ショルダーバッグ／23 x20 x5cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/29.jpg" alt="" />
              <span className="text-center">FERRAGAMO／チェーンショルダー／23 x11 x2cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ポシェット</h2>
          <p>丸みのあるコンパクトなシルエットとヴァラリボンを合わせた可愛らしい印象のバッグ。フェミニンな装いにはもちろん、ラフなファッションに甘さを足したいときにもオススメのアイテムです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/30.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/31.jpg" alt="" />
          </figure>
        </div>      
        <span className="text-center">FERRAGAMO／ヴァラ／19 x15 x7cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/32.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ショルダーバッグ／17 x12 x6cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/22/33.jpg" alt="" />
              <span className="text-center">FERRAGAMO／ヴァラ／19 x15 x6cm</span> 
          </figure>
        </div>        
        <div className="text-two-cloumn">
          <h2>フェラガモ<br className="pc"></br>（FERRAGAMO）の<br className="pc"></br>エレガントな魅力</h2>
          <p>フェラガモのバッグは、シンプルで流行に左右されないデザインが多いため、ビジネスでもカジュアルでも使え、飽きずに長く愛用できるのが魅力的。<br></br>エレガントで可愛らしい印象を作ってくれるフェラガモのバッグで、毎日のおしゃれをランクアップさせてみませんか？</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/ferragamo" className="view-all-button">
          フェラガモのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post22

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 22}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
